// extracted by mini-css-extract-plugin
export default {"loginOtherTitle":"loginOther-title-Phmq1","loginOtherList":"loginOther-list-nkgDc","loginOtherListless":"loginOther-listless-oguQ4","loginOtherItem":"loginOther-item-Bt0ru"};